// extracted by mini-css-extract-plugin
module.exports = {"debug":"Debug_debug__V4_ZI global_grid__4e_JW","visible":"Debug_visible__Tb39B","column":"Debug_column__bLc20","fpsCounter":"Debug_fpsCounter__otGwc typography_title4__uIGjC"};